import type { SvrOrgField } from '@poseidon/types/svr/svrOrg.type';

import { General } from '@poseidon/components/StrokeIcons';

import { useDeleteOrgImageMutation } from '@/hooks/trpc/useOrgMutation';

import Avatar, { type AvatarProps } from './Avatar';

type OrgAvatarProps = Omit<AvatarProps, 'onError' | 'srcs' | 'alt'> & {
  org?: {
    id: string;
    primaryFields: {
      name?: SvrOrgField;
      pictureUrl?: SvrOrgField;
    };
  };
};

export default function OrgAvatar({ org, ...props }: OrgAvatarProps) {
  const orgPictureObj = org?.primaryFields.pictureUrl;
  const orgNameObj = org?.primaryFields?.name;

  const deleteOrgImageMutation = useDeleteOrgImageMutation();

  const onError = (index: number) => {
    const source = orgPictureObj?.source;
    if (index === 0 && source && org != null) {
      deleteOrgImageMutation.mutate({ orgId: org.id, source });
    }
  };

  return (
    <Avatar
      srcs={[orgPictureObj?.data]}
      alt={orgNameObj?.data ?? ''}
      onError={onError}
      placeholder={<General.Building07 />}
      {...props}
    />
  );
}
